import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import Hero from './Hero'
import MainBlog from './MainBlog'

const Blogs = () => {
  return (
    <div>
      <Header />
      <Hero />
      <MainBlog />
      <Footer />
    </div>
  )
}

export default Blogs